import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

export const Label = styled(Typography)(
  ({ theme }) => `
  width: 100%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: ${theme.DS_spacing(['xxs'])} ${theme.DS_spacing(['xxxs'])} ;
 
`,
);

const selectStyles = ({ theme, $selected }) =>
  $selected &&
  `
     border: 2px solid ${theme.DS_palette.buttons.enabled};
     p {
      font-weight:   700;
      cursor: not-allowed;
     }

`;

const disableStyles = ({ $disabled }) =>
  $disabled &&
  `
    display: none;
`;

export const ButtonWrapper = styled('button')(
  ({ theme, $selected, $disabled }) => `
  width: 100%;
  min-height: ${theme.DS_spacing(['xl'])};
  background-color: ${theme.DS_palette.primary.white};
  border:1px solid ${theme.DS_palette.border.form};
  border-radius: ${theme.DS_border.radius.dates};
  display: flex;
  justify-content: center;
  align-items: center;
  
  margin: ${theme.DS_spacing(['xxxs'])} 0 ;

  &:hover {
     border: 2px solid ${theme.DS_palette.buttons.enabled};
       p {
        font-weight: 700;
       }
  }
  ${theme.breakpoints.up('md')} {
    min-height: ${theme.DS_spacing(['xl'])};
  }
  ${selectStyles({ $selected, theme })};
  ${disableStyles({ $disabled })};
`,
);
